module.exports = __webpack_public_path__ + "static/media/pdf-file-blue.99f3ffbb.svg";